import { render } from "./ResourceManagementCreateFolderDialog.vue?vue&type=template&id=33cec4fd&ts=true"
import script from "./ResourceManagementCreateFolderDialog.vue?vue&type=script&lang=ts"
export * from "./ResourceManagementCreateFolderDialog.vue?vue&type=script&lang=ts"

import "./ResourceManagementCreateFolderDialog.vue?vue&type=style&index=0&id=33cec4fd&lang=scss"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__